import { theme } from '@stratumn/atomic';
import globalSize from './globalSize';

export default {
  ...theme,
  globalSize
};
